import { Box } from '@atlaskit/primitives';
import * as Sentry from '@sentry/react';
import type { FallbackRender } from '@sentry/react';
import React from 'react';

// eslint-disable-next-line @dev-agents/rules/i18n/text-wrapped-in-format-message
const defaultFallback = <Box>Something went wrong</Box>;

export const ErrorBoundary = ({
	children,
	fallback,
	onError,
}: {
	children: React.ReactNode;
	fallback?: React.ReactElement | FallbackRender | undefined;
	onError?: ((error: Error, componentStack: string, eventId: string) => void) | undefined;
}): React.JSX.Element => {
	return (
		<Sentry.ErrorBoundary fallback={fallback ?? defaultFallback} onError={onError}>
			{children}
		</Sentry.ErrorBoundary>
	);
};
